import { connect } from 'react-redux';
import noop from 'lodash/noop';
import isEmpty from 'lodash/isEmpty';
import MainMenu from './MainMenu';
import { logout } from '@actions/auth';
import Pages from '@pages/names';
import { isCleanExit } from '@selectors/matches';

export const loggedInKeys = [
  Pages.Matches,
  Pages.Snapshot,
  Pages.Ranking,
  Pages.MyRankings,
  Pages.Scores,
  Pages.MyProfile,
];
export const nonLoggedInKeys = [Pages.Home, Pages.Login];

export const exit =
  (win = window) =>
  (dispatch, getState) => {
    if (
      !isCleanExit(getState()) &&
      !win.confirm('Su pronóstico tiene cambios sin guardar, salir?')
    )
      return;

    dispatch(logout());
    dispatch({ type: 'PAGE_HOME' });
  };

export const mapStateToProps = (state) => {
  let isLoggedIn = !isEmpty(state.jwToken);
  let itemsKey = isLoggedIn ? loggedInKeys : nonLoggedInKeys;

  return {
    selected: itemsKey.includes(state.page)
      ? state.page
      : state.page === Pages.Rules
        ? Pages.Rules
        : noop(),
    isLoggedIn,
    itemsKey,
  };
};

export const mapDispatchToProps = (dispatch) => ({
  onLogoutClick: () => dispatch(exit()),
});

export default connect(mapStateToProps, mapDispatchToProps)(MainMenu);
